export default "__VITE_ASSET__d04716b6__"